export const tagFieldNameToArray = (tagFieldName: string): string[] => tagFieldName.toLowerCase().split(",");
